export default

class TrackerController{
    constructor(resource) {
        this._resource = resource;
    }

    getAll() {
        return this._resource('vehicle-category')
            .get()
            .then(res => res.json())
            .catch(error => console.log(error))
    }
}
